import {
  Box,
  Button,
  CircularProgress,
  FormHelperText,
  Grid,
  TextField,
  Typography,
  Paper,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Divider,
  TableBody,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableFooter,
  Dialog,
  DialogContent
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { Formik } from 'formik';
import React, { useCallback, useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import axios from 'axios';
import QRCode from 'qrcode';
import useIsMountedRef from 'src/hooks/useIsMountedRef';

const RequestForService = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [serviceType, setServiceType] = useState('');
  const [collectionType, setCollectionType] = useState({
    data: null,
    ready: false
  });
  const [templateList, setTemplateList] = useState({
    data: [],
    ready: false
  });
  const [totalTemplate, setTotalTemplate] = useState(0);
  const [fundCodeId, setFundCodeId] = useState('');
  const [qrDisplay, setQrDisplay] = useState(false);
  const [qrCodeValue, setQrCodeValue] = useState('');
  // const [templateID, setTemplateID] = useState('');
  const [cemetery, setCemetery] = useState({
    data: [],
    ready: false
  });

  const isMountedRef = useIsMountedRef();

  const [collection_type_id, setCollection_type_id] = useState('');

  const handleSubmit = async (values, { resetForm, setSubmitting }) => {
    try {
      const { data } = await axios.post(
        '/api/auth/otis/create/public/request',
        values
      );
      // console.log('API Response:', data);

      if (data.message.message === 'success') {
        setQrDisplay(true);
        generateQrCode(data.message.qr_code);
      }

      enqueueSnackbar('Request submitted successfully!', {
        variant: 'success'
      });
      setTemplateList({ data: [], ready: false });
      resetForm();
      setServiceType('');
      //   if (onSuccess) {
      //     onSuccess();
      //   }
    } catch (error) {
      console.log(error);
      enqueueSnackbar('Error submitting request', {
        variant: 'error'
      });
      setSubmitting(false);
    }
  };

  const getInitialValues = () => {
    const commonFields = {
      service_type: serviceType,
      fund_code_id: fundCodeId,
      collection_type: collection_type_id,
      total_amount: totalTemplate.toString()
    };

    switch (serviceType) {
      case 'issuance':
        return {
          ...commonFields,
          payor: '',
          sex: '',
          address: `${process.env.REACT_APP_USER}, ALBAY`,

          document_date: moment(new Date()).format('YYYY-MM-DD'),
          business_type: 'N/A',
          business_info: 'N/A',
          remarks: 'N/A',
          form_type_id: '3'
        };
      case 'business':
        return {
          ...commonFields,
          payor: '',
          sex: '',
          address: '',
          document_date: moment(new Date()).format('YYYY-MM-DD'),
          business_type: '',
          business_info: '',
          remarks: '',
          form_type_id: '3'
        };
      case 'ctc-individual':
        return {
          ...commonFields,
          name: '',
          address: `${process.env.REACT_APP_USER}, ALBAY`,
          date_birth: moment(new Date()).format('YYYY-MM-DD'),
          place_birth: `${process.env.REACT_APP_USER}, ALBAY`,
          civil_status: '',
          gender: '',
          salary: '',
          business: '',
          real_property: '',
          profession: '',
          ctc_type: 'Individual',
          document_date: moment(new Date()).format('YYYY-MM-DD'),
          tin: '',
          citizenship: '',
          height_ft: '',
          weight_kg: '',
          icr_no: '',
          form_type_id: '11'
        };
      case 'ctc-corp':
        return {
          ...commonFields,
          company_name: '',
          place_business: `${process.env.REACT_APP_USER}, ALBAY`,
          kind_business: '',
          place_incorporation: `${process.env.REACT_APP_USER}, ALBAY`,
          gross_receipt: '',
          assessed_value: '',
          ctc_type: 'Corporation',
          document_date: moment(new Date()).format('YYYY-MM-DD'),
          tin: '',
          date_reg: '',
          kind_organization: '',
          form_type_id: '10'
        };
      case 'burial':
        return {
          ...commonFields,
          payee: '',
          sex: '',
          deceased_name: '',
          name_cemetery: '',
          cemetery_id: '',
          date_death: '',
          deceased_age_year: '',
          deceased_age_month: '',
          deceased_age_day: '',
          deceased_sex: '',
          document_date: moment(new Date()).format('YYYY-MM-DD'),
          nationality: '',
          cause_death: '',
          form_type_id: '13'
        };
      default:
        return commonFields;
    }
  };

  const getValidationSchema = () => {
    switch (serviceType) {
      case 'issuance':
        return Yup.object().shape({
          payor: Yup.string().required('Required'),
          sex: Yup.string().required('Required'),
          address: Yup.string().required('Required'),
          document_date: Yup.string().required('Required'),
          business_type: Yup.string().required('Required'),
          business_info: Yup.string().required('Required'),
          remarks: Yup.string().required('Required'),
          collection_type: Yup.string().required('Required')
        });
      case 'business':
        return Yup.object().shape({
          payor: Yup.string().required('Required'),
          sex: Yup.string().required('Required'),
          address: Yup.string().required('Required'),
          document_date: Yup.string().required('Required'),
          business_type: Yup.string().required('Required'),
          business_info: Yup.string().required('Required'),
          remarks: Yup.string().required('Required')
        });
      case 'ctc-individual':
        return Yup.object().shape({
          name: Yup.string().required('Required'),
          address: Yup.string().required('Required'),
          date_birth: Yup.string().required('Required'),
          place_birth: Yup.string().required('Required'),
          civil_status: Yup.string().required('Required'),
          gender: Yup.string().required('Required'),
          salary: Yup.string().required('Required'),
          business: Yup.string().required('Required'),
          real_property: Yup.string().required('Required'),
          profession: Yup.string().required('Required'),
          document_date: Yup.string().required('Required'),
          tin: Yup.string().required('Required'),
          citizenship: Yup.string().required('Required'),
          height_ft: Yup.string().required('Required'),
          weight_kg: Yup.string().required('Required'),
          icr_no: Yup.string().required('Required')
        });
      case 'ctc-corp':
        return Yup.object().shape({
          company_name: Yup.string().required('Required'),
          place_business: Yup.string().required('Required'),
          kind_business: Yup.string().required('Required'),
          place_incorporation: Yup.string().required('Required'),
          gross_receipt: Yup.string().required('Required'),
          assessed_value: Yup.string().required('Required'),
          document_date: Yup.string().required('Required'),
          tin: Yup.string().required('Required'),
          date_reg: Yup.string().required('Required'),
          kind_organization: Yup.string().required('Required')
        });
      case 'burial':
        return Yup.object().shape({
          payee: Yup.string().required('Required'),
          sex: Yup.string().required('Required'),
          deceased_name: Yup.string().required('Required'),
          name_cemetery: Yup.string().required('Required'),
          date_death: Yup.string().required('Required'),
          deceased_age_year: Yup.string().required('Required'),
          deceased_age_month: Yup.string().required('Required'),
          deceased_age_day: Yup.string().required('Required'),
          deceased_sex: Yup.string().required('Required'),
          document_date: Yup.string().required('Required'),
          nationality: Yup.string().required('Required'),
          cause_death: Yup.string().required('Required')
        });
      default:
        return Yup.object().shape({});
    }
  };

  const handleGetCollectionType = id => {
    var params = {
      id
    };
    axios
      .get('/api/auth/otis/get/public/collection-type', { params })
      .then(response => {
        setCollectionType({ data: response.data, ready: true });
      });
  };

  // Helper function to get the selected collection type object
  const getSelectedCollectionType = collectionTypeId => {
    if (
      !collectionTypeId ||
      !collectionType.data ||
      collectionType.data.length === 0
    ) {
      return null;
    }
    return (
      collectionType.data.find(item => item.id === collectionTypeId) || null
    );
  };

  const handleGetTemplateID = async (id, setFieldValue) => {
    // setTemplateInfo({ data: null, ready: false });
    var params = { id };
    const response = await axios.get(
      '/api/auth/otis/get/public/template-by-id',
      {
        params
      }
    );
    if (response.data.length > 0) {
      const data = response.data;
      setTemplateList({ data, ready: true });
      setFieldValue('fund_code_id', data[0].fund_code);
      setFundCodeId(data[0].fund_code);
      setCollection_type_id(data[0].collection_type_id);

      if (data.length > 0) {
        var total = 0;
        for (let x = 0; x < data.length; x++) {
          const element = data[x];
          total += parseFloat(element.amount);
        }
        setTotalTemplate(total);
      }

      //   console.log('DISPLAY ADD TO TABLE');
      //   setDialogOpen(true);
    }
  };

  const handleGetFixedTemplate = async category => {
    let url = '';
    if (category === 'ctc-individual') {
      url = '/api/auth/otis/get/public/ctc-ind/template-by-id';
    } else if (category === 'ctc-corp') {
      url = '/api/auth/otis/get/public/ctc-corp/template-by-id';
    } else if (category === 'burial') {
      url = '/api/auth/otis/get/public/burial/template-by-id';
    }
    const response = await axios.get(url);
    if (response.data.length > 0) {
      const data = response.data;
      setTemplateList({ data, ready: true });
      setFundCodeId(data[0].fund_code);
      setCollection_type_id(data[0].collection_type_id);

      if (data.length > 0) {
        var total = 0;
        for (let x = 0; x < data.length; x++) {
          const element = data[x];
          total += parseFloat(element.amount);
        }
        setTotalTemplate(total);
      }
    }
  };

  const generateQrCode = async code => {
    // console.log('RESULT: ', `${id}_${name}`);
    try {
      const response = await QRCode.toDataURL(`${code}`);
      setQrCodeValue(response);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllCemetery = useCallback(() => {
    axios.get(`/api/auth/otis/get/public/cemetery`).then(response => {
      if (isMountedRef.current) {
        setCemetery({ data: response.data, ready: true });
      }
    });
  }, [isMountedRef]);

  useEffect(() => {
    getAllCemetery();
  }, [getAllCemetery]);

  return (
    <Box p={3}>
      <Paper elevation={3} style={{ padding: 24 }}>
        <Typography variant="h4" gutterBottom>
          Request For Service
        </Typography>
        <Typography variant="body2" color="textSecondary" paragraph>
          Please select a service type and fill in the required information
        </Typography>

        <Box mb={3}>
          <FormControl fullWidth variant="outlined" margin="dense">
            <InputLabel>Select Service Type</InputLabel>
            <Select
              value={serviceType}
              onChange={e => {
                setServiceType(e.target.value);
                setTemplateList({ data: [], ready: false });

                if (e.target.value === 'issuance') {
                  handleGetCollectionType();
                }
                if (e.target.value === 'ctc-individual') {
                  handleGetFixedTemplate('ctc-individual');
                }
                if (e.target.value === 'ctc-corp') {
                  handleGetFixedTemplate('ctc-corp');
                }
                if (e.target.value === 'burial') {
                  handleGetFixedTemplate('burial');
                }
              }}
              label="Select Service Type"
            >
              <MenuItem value="">-</MenuItem>
              <MenuItem value="issuance">Other Online Request</MenuItem>

              {/* <MenuItem value="business">Business Permit</MenuItem> */}
              <MenuItem value="ctc-individual">CTC Individual</MenuItem>
              <MenuItem value="ctc-corp">CTC Corporation</MenuItem>
              <MenuItem value="burial">Burial Permit</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Divider />

        {serviceType && (
          <Formik
            initialValues={getInitialValues()}
            enableReinitialize
            validationSchema={getValidationSchema()}
            onSubmit={handleSubmit}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values,
              setFieldValue,
              resetForm
            }) =>
              isSubmitting ? (
                <Box display="flex" justifyContent="center" my={5}>
                  <CircularProgress />
                </Box>
              ) : (
                <form onSubmit={handleSubmit} style={{ marginTop: 10 }}>
                  <Box display="flex" justifyContent="flex-end" mt={3}>
                    <Button
                      variant="outlined"
                      style={{ marginRight: 10 }}
                      onClick={() => {
                        resetForm();
                        setServiceType('');
                        setTemplateList({ data: [], ready: false });
                      }}
                    >
                      Clear
                    </Button>
                    <Button
                      color="primary"
                      disabled={isSubmitting || templateList.data.length === 0}
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      Pay Onsite & Submit
                    </Button>
                  </Box>
                  <Grid container spacing={1}>
                    {/* Issuance Fields */}
                    {serviceType === 'issuance' && (
                      <>
                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            fullWidth
                            options={collectionType.data || []}
                            getOptionLabel={option => option.description || ''}
                            value={getSelectedCollectionType(
                              parseInt(values.collection_type)
                            )}
                            onChange={(event, newValue) => {
                              const value = newValue ? newValue.id : '';
                              handleGetTemplateID(value, setFieldValue);
                              setFieldValue('collection_type', value);
                            }}
                            onBlur={handleBlur}
                            renderInput={params => (
                              <TextField
                                {...params}
                                error={Boolean(
                                  touched.collection_type &&
                                    errors.collection_type
                                )}
                                helperText={
                                  touched.collection_type &&
                                  errors.collection_type
                                }
                                label="Collection Type"
                                name="collection_type"
                                variant="outlined"
                                margin="dense"
                                size="small"
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                            )}
                            noOptionsText="No collection type found"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.payor && errors.payor)}
                            fullWidth
                            helperText={touched.payor && errors.payor}
                            label="Payor"
                            name="payor"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.payor}
                            variant="outlined"
                            margin="dense"
                            multiline
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.sex && errors.sex)}
                            fullWidth
                            helperText={touched.sex && errors.sex}
                            label="Gender"
                            name="sex"
                            select
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.sex}
                            variant="outlined"
                            SelectProps={{ native: true }}
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          >
                            <option value="">-</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.address && errors.address)}
                            fullWidth
                            helperText={touched.address && errors.address}
                            label="Address"
                            name="address"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.address}
                            variant="outlined"
                            margin="dense"
                            multiline
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.document_date && errors.document_date
                            )}
                            fullWidth
                            helperText={
                              touched.document_date && errors.document_date
                            }
                            name="document_date"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.document_date}
                            label="Document Date"
                            variant="outlined"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.business_type && errors.business_type
                            )}
                            fullWidth
                            helperText={
                              touched.business_type && errors.business_type
                            }
                            label="Business Type"
                            name="business_type"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.business_type}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.business_info && errors.business_info
                            )}
                            fullWidth
                            helperText={
                              touched.business_info && errors.business_info
                            }
                            label="Business Info"
                            name="business_info"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.business_info}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.remarks && errors.remarks)}
                            fullWidth
                            helperText={touched.remarks && errors.remarks}
                            label="Remarks"
                            name="remarks"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.remarks}
                            variant="outlined"
                            margin="dense"
                            multiline
                          />
                        </Grid>
                      </>
                    )}

                    {/* Business Permit Fields */}
                    {serviceType === 'business' && (
                      <>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.payor && errors.payor)}
                            fullWidth
                            helperText={touched.payor && errors.payor}
                            label="Payor"
                            name="payor"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.payor}
                            variant="outlined"
                            margin="dense"
                            multiline
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.sex && errors.sex)}
                            fullWidth
                            helperText={touched.sex && errors.sex}
                            label="Gender"
                            name="sex"
                            select
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.sex}
                            variant="outlined"
                            SelectProps={{ native: true }}
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          >
                            <option value="">-</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </TextField>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            error={Boolean(touched.address && errors.address)}
                            fullWidth
                            helperText={touched.address && errors.address}
                            label="Address"
                            name="address"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.address}
                            variant="outlined"
                            margin="dense"
                            multiline
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.document_date && errors.document_date
                            )}
                            fullWidth
                            helperText={
                              touched.document_date && errors.document_date
                            }
                            name="document_date"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.document_date}
                            label="Document Date"
                            variant="outlined"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.business_type && errors.business_type
                            )}
                            fullWidth
                            helperText={
                              touched.business_type && errors.business_type
                            }
                            label="Business Type"
                            name="business_type"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.business_type}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            error={Boolean(
                              touched.business_info && errors.business_info
                            )}
                            fullWidth
                            helperText={
                              touched.business_info && errors.business_info
                            }
                            label="Business Info"
                            name="business_info"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.business_info}
                            variant="outlined"
                            margin="dense"
                            multiline
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            error={Boolean(touched.remarks && errors.remarks)}
                            fullWidth
                            helperText={touched.remarks && errors.remarks}
                            label="Remarks"
                            name="remarks"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.remarks}
                            variant="outlined"
                            margin="dense"
                            multiline
                          />
                        </Grid>
                      </>
                    )}

                    {/* CTC Individual Fields */}
                    {serviceType === 'ctc-individual' && (
                      <>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.name && errors.name)}
                            fullWidth
                            helperText={touched.name && errors.name}
                            label="Name"
                            name="name"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.name}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.address && errors.address)}
                            fullWidth
                            helperText={touched.address && errors.address}
                            label="Address"
                            name="address"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.address}
                            variant="outlined"
                            margin="dense"
                            multiline
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.date_birth && errors.date_birth
                            )}
                            fullWidth
                            helperText={touched.date_birth && errors.date_birth}
                            name="date_birth"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.date_birth}
                            label="Date of Birth"
                            variant="outlined"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.place_birth && errors.place_birth
                            )}
                            fullWidth
                            helperText={
                              touched.place_birth && errors.place_birth
                            }
                            label="Place of Birth"
                            name="place_birth"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.place_birth}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.civil_status && errors.civil_status
                            )}
                            fullWidth
                            helperText={
                              touched.civil_status && errors.civil_status
                            }
                            label="Civil Status"
                            name="civil_status"
                            select
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.civil_status}
                            variant="outlined"
                            SelectProps={{ native: true }}
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          >
                            <option value="">-</option>
                            <option value="single">Single</option>
                            <option value="married">Married</option>
                            <option value="widow">
                              Widow/Widower/Legally Separated
                            </option>
                            <option value="divorced">Divorced</option>
                          </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.gender && errors.gender)}
                            fullWidth
                            helperText={touched.gender && errors.gender}
                            label="Gender"
                            name="gender"
                            select
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.gender}
                            variant="outlined"
                            SelectProps={{ native: true }}
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          >
                            <option value="">-</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.profession && errors.profession
                            )}
                            fullWidth
                            helperText={touched.profession && errors.profession}
                            label="Profession / Occupation / Business"
                            name="profession"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.profession}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.salary && errors.salary)}
                            fullWidth
                            helperText={touched.salary && errors.salary}
                            label="Gross Receipt / Salaries / Earnings"
                            name="salary"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            type="number"
                            value={values.salary}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.business && errors.business)}
                            fullWidth
                            helperText={touched.business && errors.business}
                            label="Gross Receipt of Earnings from Business"
                            name="business"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            type="number"
                            value={values.business}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.real_property && errors.real_property
                            )}
                            fullWidth
                            helperText={
                              touched.real_property && errors.real_property
                            }
                            label="Gross Income from Real Property"
                            name="real_property"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            type="number"
                            value={values.real_property}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.document_date && errors.document_date
                            )}
                            fullWidth
                            helperText={
                              touched.document_date && errors.document_date
                            }
                            name="document_date"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.document_date}
                            label="Document Date"
                            variant="outlined"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.tin && errors.tin)}
                            fullWidth
                            helperText={touched.tin && errors.tin}
                            label="TIN (If Any)"
                            name="tin"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.tin}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.citizenship && errors.citizenship
                            )}
                            fullWidth
                            helperText={
                              touched.citizenship && errors.citizenship
                            }
                            label="Citizenship"
                            name="citizenship"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.citizenship}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.height_ft && errors.height_ft
                            )}
                            fullWidth
                            helperText={touched.height_ft && errors.height_ft}
                            label="Height(ft)"
                            name="height_ft"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.height_ft}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.weight_kg && errors.weight_kg
                            )}
                            fullWidth
                            helperText={touched.weight_kg && errors.weight_kg}
                            label="Weight(kg)"
                            name="weight_kg"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.weight_kg}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.icr_no && errors.icr_no)}
                            fullWidth
                            helperText={touched.icr_no && errors.icr_no}
                            label="ICR No. (If Any)"
                            name="icr_no"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.icr_no}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                      </>
                    )}

                    {/* CTC Corp Fields */}
                    {serviceType === 'ctc-corp' && (
                      <>
                        <Grid item xs={12}>
                          <TextField
                            error={Boolean(
                              touched.company_name && errors.company_name
                            )}
                            fullWidth
                            helperText={
                              touched.company_name && errors.company_name
                            }
                            label="Company's Name"
                            name="company_name"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.company_name}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.place_business && errors.place_business
                            )}
                            fullWidth
                            helperText={
                              touched.place_business && errors.place_business
                            }
                            label="Place of Business"
                            name="place_business"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.place_business}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.kind_business && errors.kind_business
                            )}
                            fullWidth
                            helperText={
                              touched.kind_business && errors.kind_business
                            }
                            label="Kind/Nature of Business"
                            name="kind_business"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.kind_business}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            error={Boolean(
                              touched.place_incorporation &&
                                errors.place_incorporation
                            )}
                            fullWidth
                            helperText={
                              touched.place_incorporation &&
                              errors.place_incorporation
                            }
                            label="Place of Incorporation"
                            name="place_incorporation"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.place_incorporation}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.gross_receipt && errors.gross_receipt
                            )}
                            fullWidth
                            helperText={
                              touched.gross_receipt && errors.gross_receipt
                            }
                            label="Gross Receipts / Salaries / Earnings"
                            name="gross_receipt"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.gross_receipt}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.assessed_value && errors.assessed_value
                            )}
                            fullWidth
                            helperText={
                              touched.assessed_value && errors.assessed_value
                            }
                            label="Assessed Value of Real Property"
                            name="assessed_value"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.assessed_value}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            error={Boolean(
                              touched.document_date && errors.document_date
                            )}
                            fullWidth
                            helperText={
                              touched.document_date && errors.document_date
                            }
                            name="document_date"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.document_date}
                            label="Document Date"
                            variant="outlined"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            error={Boolean(touched.tin && errors.tin)}
                            fullWidth
                            helperText={touched.tin && errors.tin}
                            label="TIN (If Any)"
                            name="tin"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.tin}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            error={Boolean(touched.date_reg && errors.date_reg)}
                            fullWidth
                            helperText={touched.date_reg && errors.date_reg}
                            name="date_reg"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.date_reg}
                            label="Date of Reg/Incorporation"
                            variant="outlined"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            error={Boolean(
                              touched.kind_organization &&
                                errors.kind_organization
                            )}
                            fullWidth
                            helperText={
                              touched.kind_organization &&
                              errors.kind_organization
                            }
                            label="Kind of Organization"
                            name="kind_organization"
                            select
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.kind_organization}
                            variant="outlined"
                            SelectProps={{ native: true }}
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          >
                            <option value="">-</option>
                            <option value="Corporation">Corporation</option>
                            <option value="Association">Association</option>
                            <option value="Partnership">Partnership</option>
                          </TextField>
                        </Grid>
                      </>
                    )}

                    {/* Burial Permit Fields */}
                    {serviceType === 'burial' && (
                      <>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.payee && errors.payee)}
                            fullWidth
                            helperText={touched.payee && errors.payee}
                            label="Payee(S/F/M)"
                            name="payee"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.payee}
                            variant="outlined"
                            margin="dense"
                            multiline
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(touched.sex && errors.sex)}
                            fullWidth
                            helperText={touched.sex && errors.sex}
                            label="Gender"
                            name="sex"
                            select
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.sex}
                            variant="outlined"
                            SelectProps={{ native: true }}
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          >
                            <option value="">-</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </TextField>
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            error={Boolean(
                              touched.deceased_name && errors.deceased_name
                            )}
                            fullWidth
                            helperText={
                              touched.deceased_name && errors.deceased_name
                            }
                            label="Deceased Name(S/F/M)"
                            name="deceased_name"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.deceased_name}
                            variant="outlined"
                            margin="dense"
                            multiline
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Autocomplete
                            fullWidth
                            options={cemetery.data || []}
                            getOptionLabel={option => option.description || ''}
                            value={
                              cemetery.data?.find(
                                option =>
                                  option.description === values.name_cemetery
                              ) || null
                            }
                            onChange={(event, newValue) => {
                              if (newValue) {
                                setFieldValue(
                                  'name_cemetery',
                                  newValue.description
                                );
                                setFieldValue('cemetery_id', newValue.id);
                              } else {
                                setFieldValue('name_cemetery', '');
                                setFieldValue('cemetery_id', '');
                              }
                            }}
                            onBlur={handleBlur}
                            renderInput={params => (
                              <TextField
                                {...params}
                                error={Boolean(
                                  touched.name_cemetery && errors.name_cemetery
                                )}
                                helperText={
                                  touched.name_cemetery && errors.name_cemetery
                                }
                                label="Cemetery"
                                name="name_cemetery"
                                variant="outlined"
                                margin="dense"
                                size="small"
                                InputLabelProps={{
                                  shrink: true
                                }}
                              />
                            )}
                            noOptionsText="No cemetery found"
                          />

                          {/* <Autocomplete
                                fullWidth
                                options={cemeteries}
                                getOptionLabel={option => option.description || ''}
                                onChange={(event, newValue) => {
                                  const value = newValue
                                    ? newValue.description
                                    : '';
                                  setFieldValue('name_cemetery', value);
                                }}
                                renderInput={params => (
                                  <TextField
                                    {...params}
                                    error={Boolean(
                                      touched.name_cemetery && errors.name_cemetery
                                    )}
                                    helperText={
                                      touched.name_cemetery && errors.name_cemetery
                                    }
                                    label="Cemetery"
                                    name="name_cemetery"
                                    variant="outlined"
                                    margin="dense"
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                  />
                                )}
                              /> */}
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.date_death && errors.date_death
                            )}
                            fullWidth
                            helperText={touched.date_death && errors.date_death}
                            name="date_death"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.date_death}
                            label="Date Death"
                            variant="outlined"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.document_date && errors.document_date
                            )}
                            fullWidth
                            helperText={
                              touched.document_date && errors.document_date
                            }
                            name="document_date"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.document_date}
                            label="Document Date"
                            variant="outlined"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            error={Boolean(
                              touched.deceased_age_year &&
                                errors.deceased_age_year
                            )}
                            fullWidth
                            helperText={
                              touched.deceased_age_year &&
                              errors.deceased_age_year
                            }
                            label="Age - Year"
                            name="deceased_age_year"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.deceased_age_year}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            error={Boolean(
                              touched.deceased_age_month &&
                                errors.deceased_age_month
                            )}
                            fullWidth
                            helperText={
                              touched.deceased_age_month &&
                              errors.deceased_age_month
                            }
                            label="Age - Month"
                            name="deceased_age_month"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.deceased_age_month}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={4}>
                          <TextField
                            error={Boolean(
                              touched.deceased_age_day &&
                                errors.deceased_age_day
                            )}
                            fullWidth
                            helperText={
                              touched.deceased_age_day &&
                              errors.deceased_age_day
                            }
                            label="Age - Day"
                            name="deceased_age_day"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.deceased_age_day}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.deceased_sex && errors.deceased_sex
                            )}
                            fullWidth
                            helperText={
                              touched.deceased_sex && errors.deceased_sex
                            }
                            label="Deceased Gender"
                            name="deceased_sex"
                            select
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.deceased_sex}
                            variant="outlined"
                            SelectProps={{ native: true }}
                            InputLabelProps={{ shrink: true }}
                            margin="dense"
                          >
                            <option value="">-</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            error={Boolean(
                              touched.nationality && errors.nationality
                            )}
                            fullWidth
                            helperText={
                              touched.nationality && errors.nationality
                            }
                            label="Nationality"
                            name="nationality"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.nationality}
                            variant="outlined"
                            margin="dense"
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            error={Boolean(
                              touched.cause_death && errors.cause_death
                            )}
                            fullWidth
                            helperText={
                              touched.cause_death && errors.cause_death
                            }
                            label="Cause Death"
                            name="cause_death"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.cause_death}
                            variant="outlined"
                            margin="dense"
                            multiline
                          />
                        </Grid>
                      </>
                    )}
                  </Grid>

                  {Boolean(touched.policy && errors.policy) && (
                    <FormHelperText error>{errors.policy}</FormHelperText>
                  )}
                </form>
              )
            }
          </Formik>
        )}

        {templateList.ready && templateList.data.length > 0 && (
          <Grid container spacing={1} style={{ marginTop: 10 }}>
            <Grid item xs={12}>
              <Typography variant="h6">Template List</Typography>
            </Grid>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Particulars</TableCell>
                    <TableCell align="center">Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {templateList.data.map(item => (
                    <TableRow key={item.id}>
                      <TableCell>{item.acc_desc}</TableCell>
                      <TableCell align="right">
                        {parseFloat(item.amount).toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell align="right">Total</TableCell>
                    <TableCell align="right">
                      {parseFloat(totalTemplate).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })}
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Grid>
        )}
      </Paper>

      {/* QR CODE */}
      <Dialog
        open={qrDisplay}
        onClose={() => {
          setQrDisplay(false);
        }}
      >
        <DialogContent>
          <Box
            display={'flex'}
            justifyContent="center"
            alignItems={'center'}
            style={{ padding: 10, flexDirection: 'column' }}
          >
            <Box mb={1}>
              {qrCodeValue ? (
                <a href={qrCodeValue} download>
                  <img src={qrCodeValue} alt="img" style={{ width: 200 }} />
                </a>
              ) : null}
            </Box>
            <Typography>Click the QR Code to Download!</Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default RequestForService;
